import { AxiosResponse } from 'axios';

import { messages } from '@qality/common-messages';
import { AttachmentFile, JiraAttachment } from '@qality/common-model';
import { APResponse } from '@qality/common-model/src/AP/AP';
import { StorageOfUniqueServices } from '@qality/common-service';

import API from './API';

type AttachmentServiceFunctions = {
  deleteAttachment: (id: number) => Promise<APResponse>;
  fetchAttachment: (attachmentId: number) => Promise<APResponse>;
  postAttachment: (
    issueIdOrKey: string | number,
    file: File
  ) => Promise<APResponse>;
  postAttachments: (
    issueIdOrKey: string | number,
    files: Array<AttachmentFile>
  ) => Promise<Array<JiraAttachment>>;
};
export default {
  async postAttachments(
    issueIdOrKey: string | number,
    files: Array<AttachmentFile>
  ): Promise<Array<JiraAttachment>> {
    const promises = [];

    files.forEach((file) => {
      promises.push(fileAsyncHandler(file, issueIdOrKey, this));
    });

    return Promise.all(promises).then((responses) => {
      return responses.map((response) => {
        const attachments = JSON.parse(response.body);
        return attachments[0];
      });
    });
  },

  postAttachment(
    issueIdOrKey: string | number,
    file: AttachmentFile
  ): Promise<AxiosResponse | APResponse> {
    return API.request({
      url: `/rest/api/2/issue/${issueIdOrKey}/attachments`,
      type: 'POST',
      headers: {
        'X-Atlassian-Token': 'no-check',
      },
      contentType: 'multipart/form-data',
      data: { file: file },
    });
  },

  fetchAttachment(attachmentId: number): Promise<AxiosResponse | APResponse> {
    return API.noRetry({
      type: 'GET',
      url: `/rest/api/2/attachment/${attachmentId}`,
    });
  },

  deleteAttachment(id: number): Promise<AxiosResponse | APResponse> {
    return API.request({
      type: 'DELETE',
      url: `/rest/api/2/attachment/${id}`,
    });
  },
};

function fileAsyncHandler(
  file: AttachmentFile,
  issueKey: string | number,
  attachmentService: AttachmentServiceFunctions
): Promise<APResponse> {
  return new Promise((resolve, reject) => {
    try {
      const reader = new FileReader();

      reader.onload = (function (e) {
        return function () {
          const newFile = new File([e.result], file.name, {
            type: file.type,
          });
          resolve(attachmentService.postAttachment(issueKey, newFile));
        };
      })(reader);

      reader.onerror = reject;

      reader.readAsArrayBuffer(file);
    } catch (e) {
      StorageOfUniqueServices.get('ErrorHandlingUtils').handleError(
        e,
        messages['error.testCaseBox.postAttachment.message']
      );
    }
  });
}
